module.exports = __webpack_public_path__ + "media/audios/kid/lesson_1/audio_tpc1-a14a1d87f1690e00ad8c71488b887972.m4a";